import { render, staticRenderFns } from "./payResult.vue?vue&type=template&id=66af6c80"
import script from "./payResult.vue?vue&type=script&lang=js"
export * from "./payResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports